import { useEffect, useState } from "react";
import { Check, X, ArrowUpCircle, ArrowDownCircle } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export const PackageRequestsPanel = ({ canManage, packages, onDecided }) => {
  const [items, setItems] = useState([]);
  const load = async () => setItems((await api.get("/admin/package-requests")).data);
  useEffect(() => { load(); }, []);

  const name = (code) => packages.find((p) => p.code === code)?.name || code;

  const decide = async (r, action) => {
    const body = action === "reject" ? { reason: window.prompt("Red gerekçesi (isteğe bağlı):") || null } : undefined;
    try {
      const { data } = await api.post(`/admin/package-requests/${r.id}/${action}`, body);
      toast.success(action === "approve" ? "Talep onaylandı, paket değişti" : "Talep reddedildi");
      data?.warnings?.forEach((w) => toast.warning(w));
      load();
      onDecided();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  if (!items.length) return null;
  return (
    <Card data-testid="package-requests-panel" className="border-blue-200 overflow-hidden">
      <div className="px-5 py-3 bg-blue-50 border-b border-blue-200 font-semibold text-blue-900 text-sm">Onay Bekleyen Paket Değişiklikleri ({items.length})</div>
      {items.map((r) => (
        <div key={r.id} data-testid={`package-request-${r.office_code}`} className="px-5 py-3 border-b last:border-0 flex items-center justify-between gap-4 flex-wrap">
          <div className="text-sm">
            <div className="font-semibold">{r.office_name} <span className="font-mono text-xs text-slate-500">{r.office_code}</span></div>
            <div className="text-slate-600 flex items-center gap-1.5 mt-0.5">
              {r.direction === "UPGRADE" ? <ArrowUpCircle className="w-4 h-4 text-emerald-600" /> : <ArrowDownCircle className="w-4 h-4 text-amber-600" />}
              {name(r.from_package)} → <b>{name(r.to_package)}</b>
              <Badge variant="outline" className="ml-1">{r.direction === "UPGRADE" ? "Yükseltme" : "Düşürme"}</Badge>
              {r.campaign_code && <Badge variant="outline" className="border-emerald-400 text-emerald-700">Kampanya: {r.campaign_code}</Badge>}
            </div>
            <div className="text-xs text-slate-500 mt-0.5">{r.requested_by_name} · {new Date(r.created_at).toLocaleString("tr-TR")}</div>
          </div>
          {canManage && (
            <div className="flex gap-2">
              <Button size="sm" data-testid={`approve-package-${r.office_code}`} className="bg-emerald-600 hover:bg-emerald-700" onClick={() => decide(r, "approve")}><Check className="w-4 h-4 mr-1" />Onayla</Button>
              <Button size="sm" variant="outline" data-testid={`reject-package-${r.office_code}`} onClick={() => decide(r, "reject")}><X className="w-4 h-4 mr-1" />Reddet</Button>
            </div>
          )}
        </div>
      ))}
    </Card>
  );
};
